import { render, staticRenderFns } from "./Pools.vue?vue&type=template&id=2b04ed28&"
import script from "./Pools.vue?vue&type=script&lang=js&"
export * from "./Pools.vue?vue&type=script&lang=js&"
import style0 from "./Pools.vue?vue&type=style&index=0&id=2b04ed28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports